export default "__VITE_ASSET__CRUIUGa6__"